export default __webpack_public_path__ + "static/uk-145f7f292cc3e978338eaf361702e186.webp";